import Button from '@/src/common/components/marketing/buttons/Button'
import handleEnterPressEvent from '@/src/common/utilities/handleEnterPressEvent'
import { styled } from '@/src/stitches.config'
import Image from 'next/image'

const StyledButton = styled(Button, {
    display: 'flex',
    minHeight: 200,
    '& p': {
        mb: 0,
        fontSize: '.8rem',
        lineHeight: 1.35,
    },
})
const ContentWrapper = styled('div', {
    width: '60%',
    py: 10,
    '& p': {
        textAlign: 'left',
        fontWeight: 'normal',
    },
    '.option': {
        fontSize: '1rem',
        fontWeight: 'bold',
    },
    '.header': {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: '$darkest',
        mb: 5,
    },
    '.blueText': {
        fontSize: '1.2rem',
        fontWeight: 800,
        color: '$secondary',
    },
})
const ImageWrapper = styled('div', {
    margin: 'auto',
    width: '30%',
    '& img': {
        width: '100%',
        height: 'auto',
    },
})

const DetailedOptionButton = ({
    header,
    description,
    image,
    altText,
    onClick,
    imageWidth,
    imageHeight,
    isActive,
    blueText = '',
    headerFontSize = '1.2rem',
    optionNumber,
}: {
    optionNumber?: string
    header: string
    description: string
    image: string
    altText: string
    onClick: Function
    imageWidth: number
    imageHeight: number
    isActive: boolean
    blueText?: string
    headerFontSize?: string | number
}) => {
    return (
        <StyledButton
            label={''}
            variant={'graySquareButtonWithGradient'}
            onClick={() => onClick()}
            onKeyDown={(e) => handleEnterPressEvent(e, onClick)}
            style={{
                justifyContent: 'unset',
                borderWidth: '3px',
                maxWidth: 500,
                width: '100%',
                minHeight: '10.5rem',
            }}
            className={isActive ? 'active-button-gradient' : ''}
            width={'full'}
        >
            <ContentWrapper>
                {blueText ? (
                    <p
                        className={'blueText'}
                        style={{ fontSize: headerFontSize }}
                    >
                        {blueText}
                    </p>
                ) : (
                    ''
                )}
                {optionNumber ? (
                    <p className={'option'}>Option {optionNumber}</p>
                ) : (
                    ''
                )}
                <p className={'header'} style={{ fontSize: headerFontSize }}>
                    {header}
                </p>
                <p>{description}</p>
            </ContentWrapper>
            <ImageWrapper>
                <Image
                    src={image}
                    alt={altText}
                    width={imageWidth}
                    height={imageHeight}
                />
            </ImageWrapper>
        </StyledButton>
    )
}

export default DetailedOptionButton
